import { createContext, useContext, useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

const STORAGE_KEY = 'am_user';
const AuthContext = createContext(null);

function readStoredUser() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

// Shared site-wide auth — one login (validated against the employees table)
// grants access to Hub, Agreement, Admin and Customers without re-prompting.
// Backed by Context so every page sees the same live session instantly
// (e.g. the sidebar updates the moment Hub.js logs someone in).
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(readStoredUser);

  const login = useCallback(async (username, password) => {
    const { data, error } = await supabase.rpc('validate_employee', {
      p_username: username,
      p_password: password,
    });
    if (error || !data?.success) return { success: false };
    setCurrentUser(data.user);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data.user));
    return { success: true, user: data.user };
  }, []);

  const logout = useCallback(() => {
    setCurrentUser(null);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
